import { useTranslation } from 'react-i18next';

export type U2000AutoCompleteSearchCountFooterProps = {
  displayedCount: number;
  totalCount?: number;
};

/** Pied de liste autocomplete : « {{count}} sur {{total}} » (i18n common, BL-0047). */
export function U2000AutoCompleteSearchCountFooter({
  displayedCount,
  totalCount,
}: U2000AutoCompleteSearchCountFooterProps) {
  const { t } = useTranslation('common');
  if (displayedCount <= 0) {
    return null;
  }
  const footerTotal = totalCount ?? displayedCount;
  return (
    <div className="shrink-0 border-t surface-border bg-surface px-3 py-1.5 text-xs text-gray-500">
      {t('autocompleteFooterCountOfTotal', { count: displayedCount, total: footerTotal })}
    </div>
  );
}
